import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { Box, Grid, MenuItem, Modal, Select, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";
import MDModal from "components/MDModal";
import { useProduct } from "context/ProductContext";
import { genderOptions } from "constants/CodConstants";
import axios from "axios";
import { useHookFormMask, withMask } from "use-mask-input";
import { SearchProvider } from "context/SearchContext";
import SearchCategory from "components/SearchCategory";

function ProductsForm({ setShowForm }) {
  const [dataCategory, setDataCategory] = useState({});
  const { storeProduct, updateProduct, editProduct, setEditProduct, loading, setLoading } =
    useProduct();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm();
  const registerWithMask = useHookFormMask(register);

  const onHandleSubmit = (data) => {
    data["category_id"] = dataCategory.id;
    if (Object.keys(editProduct).length != 0) {
      setShowForm(false);
      return updateProduct(data);
    }
    setEditProduct({});
    storeProduct(data);
    setShowForm(false);
  };

  const onCancelEditProduct = () => {
    setEditProduct({});
    reset({
      name: "",
      descricao: "",
      ean: "",
      priceRetail: "",
      priceWholesale: "",
      qtd_stock: "",
      validity: "",
      weight: "",
    });
  };

  useEffect(() => {
    reset(editProduct);
  }, [editProduct]);

  return (
    <MDBox sx={{ p: 2 }}>
      <Grid
        container
        spacing={2}
        component="form"
        onSubmit={handleSubmit(onHandleSubmit)}
        role="form"
      >
        <SearchProvider>
          <Grid container sx={{ p: 2 }}>
            <SearchCategory dataCategory={dataCategory} setDataCategory={setDataCategory} />
          </Grid>
        </SearchProvider>
        <Grid item xs={12}>
          <MDInput
            variant="outlined"
            required
            fullWidth
            id="name"
            label="Nome"
            name="name"
            {...register("name")}
            // value={formData.name}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            variant="outlined"
            fullWidth
            id="descricao"
            label="Descrição"
            name="descricao"
            {...register("descricao")}
            // value={formData.name}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={8}>
          <MDInput
            variant="outlined"
            fullWidth
            id="ean"
            label="Ean"
            name="ean"
            {...registerWithMask("ean", "integer", {
              inputFormat: "999999",
              replacement: { 9: /\d/ },
            })}
            // value={formData.ean}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={2}>
          <MDInput
            variant="outlined"
            fullWidth
            id="priceRetail"
            label="Preço Varejo"
            placeholder="Preço Varejo"
            name="priceRetail"
            {...registerWithMask("priceRetail", "decimal", {
              replacement: { 9: /\d/ },
            })}
          />
        </Grid>
        <Grid item xs={2}>
          <MDInput
            variant="outlined"
            fullWidth
            id="priceWholesale"
            label="Preço Atacado"
            name="priceWholesale"
            {...registerWithMask("priceWholesale", "decimal", {
              replacement: { 9: /\d/ },
            })}
            // value={formData.priceWholesale}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={4}>
          <MDInput
            variant="outlined"
            fullWidth
            id="qtd_stock"
            label="Qtd em Estoque"
            name="qtd_stock"
            // {...register("qtd_stock")}
            {...registerWithMask("qtd_stock", "integer", {
              inputFormat: "999999",
              replacement: { 9: /\d/ },
            })}
            // value={formData.qtd_stock}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={4}>
          <MDInput
            variant="outlined"
            fullWidth
            id="validity"
            label="Validade"
            name="validity"
            {...registerWithMask("validity", "datetime", {
              inputFormat: "yyyy-mm-dd",
            })}
            // value={formData.validity}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={4}>
          <MDInput
            variant="outlined"
            fullWidth
            id="weight"
            label="Peso"
            name="weight"
            {...register("weight")}
            // value={formData.weight}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} spacing={2}>
          {Object.keys(editProduct).length == 0 ? (
            <MDButton
              type="submit"
              disabled={loading}
              fullWidth
              variant="contained"
              color="primary"
            >
              Enviar
            </MDButton>
          ) : (
            <>
              <MDButton type="submit" variant="contained" color="primary">
                Editar
              </MDButton>
              <MDButton variant="contained" color="primary" onClick={onCancelEditProduct}>
                Cancelar
              </MDButton>
            </>
          )}
        </Grid>
      </Grid>
    </MDBox>
  );
}

ProductsForm.propTypes = {
  setShowForm: PropTypes.func,
};

export default ProductsForm;
